<template>
  <div class="logo-wrapper">
    <component :is="getLogo" :class="view"/>
  </div>
</template>

<script>

import {extractDomainFromUrl} from '@/utils/validationUtils';
import CynergyAppLogin from '@/assets/icons/whitelabeling/cynergy.app/cynergy-logo-black.svg?inline';
import CynergyAppNoText from '@/assets/icons/whitelabeling/cynergy.app/cynergy-logo-no-text-black.svg?inline';
import XmcyberComLogin from '@/assets/icons/whitelabeling/xmcyber.com/xmcyber_com_login.svg?inline';
import XmcyberComDashboard from '@/assets/icons/whitelabeling/xmcyber.com/xmcyber_com_dashboard.svg?inline';
import XmcyberComNoText from '@/assets/icons/whitelabeling/xmcyber.com/xmcyber_com_no_text.svg?inline';

export default {
  name: 'CompanyLogo',
  props: {
    domain: {
      type: String,
      required: true,
      default: 'cynergy.app',
    },
    view: {
      type: String,
      required: true,
      default: 'dashboard',
    },
  },
  computed: {
    getLogo() {
      let {domain} = this;
      if (this.view === 'login' || this.view === 'register') {
        domain = extractDomainFromUrl(this.domain).domain;
      }
      const logoPath = `${domain.replace(/[-.]/g, '_')}_${this.view}`;
      switch (logoPath) {
      case 'cynergy_app_login':
        return CynergyAppLogin;
      case 'cynergy_app_register':
        return CynergyAppNoText;
      case 'xmcyber_com_login':
        return XmcyberComLogin;
      case 'xmcyber_com_dashboard':
        return XmcyberComDashboard;
      case 'xmcyber_com_ai':
        return XmcyberComNoText;
      case 'xmcyber_com_no_text':
        return XmcyberComNoText;
      case 'xmcyber_com_register':
        return XmcyberComNoText;
      case 'xmcyber_master_com_login':
        return XmcyberComLogin;
      case 'xmcyber_master_com_dashboard':
        return XmcyberComDashboard;
      case 'xmcyber_master_com_ai':
        return XmcyberComNoText;
      case 'xmcyber_master_com_no_text':
        return XmcyberComNoText;
      case 'xmcyber_master_com_register':
        return XmcyberComNoText;
      default:
        return CynergyAppNoText;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/design-system';

.logo-wrapper {
  .dashboard {
    height: rem(75);
    width: rem(75);
    fill: var(--text-primary);
    margin-top: rem(-10);
  }

  .login {
    width: inherit;
    height: rem(110);
    display: block;
    margin: auto;
  }

  .ai {
    width: $space-12;
    margin-right: $space-1;
  }

  .no_text {
    width: rem(30);
    height: rem(30);
    display: inline-block;
  }

  .register {
    height: rem(45);
    margin-top: $space-1;
  }
}
</style>
